import { z } from 'zod';

export const PassportSchema = z
  .object({
    passportNo: z.string().min(1, { message: 'Required' }),
    dateOfExpiry: z.string().min(1, { message: 'Required' }).date(),
    dateOfIssue: z.string().min(1, { message: 'Required' }).date(),
    passportIssuingAuthority: z.string().min(1, { message: 'Required' })
  })
  .superRefine((data, ctx) => {
    const { dateOfIssue, dateOfExpiry } = data;

    if (!dateOfIssue || !dateOfExpiry) return;

    const issueDate = new Date(dateOfIssue);
    const expiryDate = new Date(dateOfExpiry);
    const today = new Date();

    if (issueDate > today) {
      ctx.addIssue({
        code: 'custom',
        path: ['dateOfIssue'],
        message: 'Date of issue should be earlier than today'
      });
    }

    if (issueDate > expiryDate) {
      ctx.addIssue({
        code: 'custom',
        path: ['dateOfExpiry'],
        message: 'Date of expiry should not be earlier than date of issue'
      });
    }
  });
